/**
 * Preseed Table Configuration
 *
 * Column width tokens, default orders, and table configuration for preseed.
 * NO JSX - pure TypeScript only.
 *
 * Pattern matches:
 * - src/sections/seeds/config/columns.ts
 * - src/sections/asset/config/columns.ts
 */

// ============================================================================
// COLUMN WIDTH CONFIGURATION
// ============================================================================

/**
 * Column width tokens for preseed table
 * Pattern: { fixedWidth, minWidth, maxWidth }
 * - Omit maxWidth for expandable columns
 */
export const PRESEED_COLUMN_WIDTHS = {
  status: { fixedWidth: 120, minWidth: 120, maxWidth: 120 },
  type: { fixedWidth: 250, minWidth: 250, maxWidth: 250 },
  pattern: { fixedWidth: 300, minWidth: 300 }, // Expandable - no maxWidth
  count: { fixedWidth: 120, minWidth: 120, maxWidth: 120 },
} as const;

// ============================================================================
// DEFAULT COLUMN ORDER
// ============================================================================

/**
 * Default column order for preseed
 */
export const PRESEED_DEFAULT_COLUMN_ORDER = [
  'status',
  'type',
  'pattern',
  'count',
] as const;

// ============================================================================
// TABLE CONFIGURATION
// ============================================================================

/**
 * Complete preseed table configuration
 * Matches Seeds table pattern
 */
export const PRESEED_TABLE_CONFIG = {
  widths: PRESEED_COLUMN_WIDTHS,
  defaultColumnOrder: PRESEED_DEFAULT_COLUMN_ORDER,
  storageKey: 'seeds-preseed-v1',
  defaultRowHeight: 68, // Taller rows for type/value display
} as const;
